var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: `modal-notification-response-${_vm.notification.notification.id}`,
        role: "dialog",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("h3", [_vm._v(_vm._s(_vm.notification.notification.title))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.notification.notification.content))]),
              _vm._v(" "),
              _vm._l(
                _vm.notification.notification.responses,
                function (response) {
                  return _c(
                    "button",
                    {
                      key: response.id,
                      ref: `response-button-${response.id}`,
                      refInFor: true,
                      staticClass: "btn btn-block btn-dark",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          return _vm.handleRespondToNotificationCallback(
                            response.id
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(response.button_label) +
                          "\n        "
                      ),
                    ]
                  )
                }
              ),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }